import { useEffect, useState } from 'react';

// Hora actual, refrescada cada `intervalMs` (para cuentas atrás y "hace x s")
const useNow = (intervalMs = 1000) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
};

export default useNow;
